module.exports = __webpack_public_path__ + "static/media/a5.60009311.png";